import { LANG, LOCALIZE_NAME_OPTIONS } from "~/constans/commom";
import { FilterField } from "~/features/filter";
import { UPLOAD_OPTIONS } from "~/pages/Uploads/options";

type Translate = (key: string) => string;

export const uploadsFilterFields = (t: Translate): FilterField[] => {
  const isEn = localStorage.getItem("language") === LANG.en;

  return [
    {
      name: "searchField",
      type: "select",
      label: t("ui.filter_by"),
      options: UPLOAD_OPTIONS.filter((option) => option !== "file").map(
        (option) => ({
          value:
            LOCALIZE_NAME_OPTIONS.includes(option) && isEn
              ? `${option}En`
              : option,
          label: t(`uploads.${option}`),
        }),
      ),
    },
    {
      name: "searchText",
      type: "input",
      label: t("ui.search"),
    },
  ];
};
